module.exports = __webpack_public_path__ + "84e3855141a5a1cd2bd1a4c4972745bb.svg";